module.exports = "/build/web/images/cta.190cc4dd63de7442e1bc46953dce7979.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/cta.jpg
// module id = 119
// module chunks = 13